import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef
} from '@angular/material/dialog';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';
import { DialogData } from 'src/app/shared/purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import { WarehouseService } from 'src/app/home/services/warehouse.service';

@Component({
  selector: 'app-implant-detail-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './implant-detail-modal.component.html',
  styleUrls: ['./implant-detail-modal.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})
export class ImplantDetailModalComponent {
  public dialogData: any;

  public implantDetails: any;
  public activityTimeline: any[] = [];

  constructor(
    public warehouseService: WarehouseService,
    public dialogRef: MatDialogRef<ImplantDetailModalComponent>,
    public dialog: MatDialog,
    public location: Location,
    public router: Router,

    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getImplantDetails();
    this.loadActivityTimeline();
  }

  getImplantDetails(){
    this.warehouseService.getImplantDetails(this.dialogData.storeId, this.dialogData.implantId).subscribe((res)=>{
      if (res.data) {
        this.implantDetails = res.data;
      }
    });
  }

  loadActivityTimeline(){
    // Sample activity timeline data - replace with actual API call
    this.activityTimeline = [
      {
        type: 'created',
        title: 'Implant Created',
        description: 'Implant was added to the system',
        timestamp: '2024-01-15 10:30 AM',
        user: 'John Doe'
      },
      {
        type: 'updated',
        title: 'Status Updated',
        description: 'Implant status changed to Active',
        timestamp: '2024-01-16 02:15 PM',
        user: 'Jane Smith'
      },
      {
        type: 'moved',
        title: 'Location Changed',
        description: 'Implant moved to Cabinet A-1',
        timestamp: '2024-01-17 09:45 AM',
        user: 'Mike Johnson'
      }
    ];
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
